import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';
import StudentGoalService from '../../../services/StudentGoalService';
import Advert from '../../../components/Advert/Advert';
import Loading from '../../../components/Loading/Loading';
import './ParentGoal.scss';
import GoalNumberCard from '../../../components/parent/GoalNumberCard/GoalNumberCard';
import { useSelector } from 'react-redux';
import { Roles } from '../../../utils/Roles';
const IMG_URL = process.env.REACT_APP_IMAGE_ASSET_URL;

const applyStatusFilter = (list, select) => {
  const goalArr = list || [];
  if (select?.onTrack) return goalArr.filter((item) => item.status === 'green');
  if (select?.atRisk) return goalArr.filter((item) => item.status === 'yellow');
  if (select?.offTrack) return goalArr.filter((item) => item.status === 'red');
  if (select?.atBrown) return goalArr.filter((item) => item.status === 'brown');
  return goalArr;
};

const extractSearchStudents = (payload) => {
  const data = payload?.data ?? payload;
  if (Array.isArray(data?.list)) return data.list;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.result)) return data.result;
  if (Array.isArray(data?.objects)) return data.objects;
  if (Array.isArray(data)) return data;
  return [];
};

const getStudentDisplayName = (item) => {
  const full = `${item?.first_name || ""} ${item?.last_name || ""}`.trim();
  return full || item?.name || "";
};









const ParentGoal = () => {

  let userData = useSelector((state) => state.UserReducer.userObj);
  const lang = useSelector((state) => state.LanguageReducer.current) || 'en';
  const location = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [goalId, setGoalId] = useState('');
  const [goalData, setGoalData] = useState({});
  const [cardSelect, setcardSelect] = useState({ allStudent: true, onTrack: false, atRisk: false, offTrack: false, atBrown: false });
  const [filterStudentlist, setFilterStudentList] = useState([]);
  const [sourceStudentList, setSourceStudentList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const searchTimeout = useRef();
  const searchRequestId = useRef(0);
  const lastSearchQuery = useRef("");
  const cardSelectRef = useRef(cardSelect);
  const goalDataRef = useRef(goalData);

  useEffect(() => {
    cardSelectRef.current = cardSelect;
  }, [cardSelect]);

  useEffect(() => {
    goalDataRef.current = goalData;
  }, [goalData]);

  // i18n labels
  const labels = {
    en: {
      hello: 'Hello,',
      goalProgressSummary: 'GOAL PROGRESS SUMMARY',
      allStudent: 'All Student',
      onTrack: 'On Track',
      atRisk: 'At Risk',
      offTrack: 'Off Track',
      transcriptMissing: 'Transcript Missing',
      allStudentsProgress: 'All Students Progress',
      searchPlaceholder: 'Search students',
      emptySearch: 'No students match your search.',
      gradeLabel: 'Grade:',
      emptyOnTrack: 'You do not have any students On Track currently.',
      emptyAtRisk: 'You do not have any students At Risk currently.',
      emptyOffTrack: 'You do not have any students Off Track currently.',
      emptyAtBrown: 'You do not have any students At Brown currently.'
    },
    es: {
      hello: 'Hola,',
      goalProgressSummary: 'RESUMEN DEL PROGRESO DE LA META',
      allStudent: 'Todos los estudiantes',
      onTrack: 'En curso',
      atRisk: 'En riesgo',
      offTrack: 'Fuera de curso',
      transcriptMissing: 'Falta expediente',
      allStudentsProgress: 'Progreso de todos los estudiantes',
      searchPlaceholder: 'Buscar estudiantes',
      emptySearch: 'Ningún estudiante coincide con tu búsqueda.',
      gradeLabel: 'Grado:',
      emptyOnTrack: 'Actualmente no tienes estudiantes En curso.',
      emptyAtRisk: 'Actualmente no tienes estudiantes En riesgo.',
      emptyOffTrack: 'Actualmente no tienes estudiantes Fuera de curso.',
      emptyAtBrown: 'Actualmente no tienes estudiantes En marrón.'
    }
  };
  const t = (key) => (labels[lang] || labels.en)[key] || key;

  // Set goal by route and fetch; re-run on language change
  useEffect(() => {
    setSearchValue("");
    lastSearchQuery.current = "";
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    if (location?.pathname === '/parent/goal/cc-requirement') {
      setGoalId(65);
      getStudentByGoal(65);
    } else if (location?.pathname === '/parent/goal/csu-requirement') {
      setGoalId(68);
      getStudentByGoal(68);
    } else if (location?.pathname === '/parent/goal/uc-requirement') {
      setGoalId(45);
      getStudentByGoal(45);
    }
  }, [location?.pathname, lang]);

  useEffect(() => {
    return () => {
      if (searchTimeout.current) clearTimeout(searchTimeout.current);
    };
  }, []);













  const getStudentByGoal = (goalVal) => {
    let payload = {
      goal_id: goalVal,
      language: lang
    };
    setLoading(true);
    StudentGoalService.getParentRoleStudentListbyGoal(payload)
    .then((res) => {
      if (res?.status === 200 && res?.data) {
        setGoalData(res?.data);
        const list = res?.data?.list || [];
        setSourceStudentList(list);
        if (res?.data?.list && res?.data?.list.length > 0) {
          getParentHistoryData(res?.data?.list[0]);
        }
        setFilterStudentList(applyStatusFilter(list, cardSelectRef.current));
      } else {
        setGoalData({});
        setSourceStudentList([]);
        setFilterStudentList([]);
      }
    })
    .catch(() => {
      setGoalData({});
      setSourceStudentList([]);
      setFilterStudentList([]);
    })
    .finally(() => {
      setLoading(false);
    });
  };

  const getParentHistoryData = (studentDetail) => {
    let payload = {
      student_id: studentDetail?.id || null,
      parent_id: userData?.id || null,
      role: Roles.PARENT_NAME,
      school_id: studentDetail?.school_id || null,
      device_type: 'web',
      mobile_os: null,
      app_version: null,
      language: lang,
      logged_in_user_id: userData?.id || null
    };
    // Once per parent login session — service skips if already tracked
    StudentGoalService.getParentHistoryData(payload)
    .then(() => {})
    .catch(() => {});
  };

  const restoreGoalStudentList = (select = cardSelectRef.current) => {
    const list = goalDataRef.current?.list || [];
    setSourceStudentList(list);
    setFilterStudentList(applyStatusFilter(list, select));
  };

  const searchParentStudents = (query) => {
    const requestId = ++searchRequestId.current;
    StudentGoalService.searchParentStudents(query)
      .then((res) => {
        if (requestId !== searchRequestId.current) return;
        const list = extractSearchStudents(res);
        setSourceStudentList(list);
        setFilterStudentList(applyStatusFilter(list, cardSelectRef.current));
      })
      .catch(() => {
        if (requestId !== searchRequestId.current) return;
        setSourceStudentList([]);
        setFilterStudentList([]);
      });
  };

  const handleStudentSearchChange = (e) => {
    const nextValue = e.target.value;
    setSearchValue(nextValue);
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    const query = nextValue.trim();
    if (!query) {
      searchRequestId.current += 1;
      lastSearchQuery.current = "";
      restoreGoalStudentList();
      return;
    }
    searchTimeout.current = setTimeout(() => {
      const latest = String(nextValue || "").trim();
      if (!latest || latest === lastSearchQuery.current) return;
      lastSearchQuery.current = latest;
      searchParentStudents(latest);
    }, 600);
  };

  const handleGoalCardClick = (key) => {
    let nextSelect = { allStudent: false, onTrack: false, atRisk: false, offTrack: false, atBrown: false };
    if (key === 'allStudent') {
      nextSelect = { allStudent: true, onTrack: false, atRisk: false, offTrack: false, atBrown: false };
    } else if (key === 'onTrack') {
      nextSelect = { allStudent: false, onTrack: true, atRisk: false, offTrack: false, atBrown: false };
    } else if (key === 'atRisk') {
      nextSelect = { allStudent: false, onTrack: false, atRisk: true, offTrack: false, atBrown: false };
    } else if (key === 'offTrack') {
      nextSelect = { allStudent: false, onTrack: false, atRisk: false, offTrack: true, atBrown: false };
    } else if (key === 'atBrown') {
      nextSelect = { allStudent: false, onTrack: false, atRisk: false, offTrack: false, atBrown: true };
    }
    setcardSelect(nextSelect);
    setFilterStudentList(applyStatusFilter(sourceStudentList, nextSelect));
  };

  const getItemStatus = (statusVal) => {
    if (statusVal === 'green') {
      return t('onTrack');
    } else if (statusVal === 'yellow') {
      return t('atRisk');
    } else if (statusVal === 'red') {
      return t('offTrack');
    } else if (statusVal === 'brown') {
      return t('transcriptMissing');
    }
  };
  const handleStudentClick = (item) => {
    localStorage.setItem("studentData", JSON.stringify(item));
    history.push(`/parent/goal/student-course-detail?goalId=${goalId || ''}`);
  };

  const getEmtptyArrMsg = () => {
    if (searchValue.trim()) {
      return t('emptySearch');
    }
    if (cardSelect?.onTrack === true) {
      return t('emptyOnTrack');
    } else if (cardSelect?.atRisk === true) {
      return t('emptyAtRisk');
    } else if (cardSelect?.offTrack === true) {
      return t('emptyOffTrack');
    } else if (cardSelect?.atBrown === true) {
      return t('emptyAtBrown');
    }
  };

  return (
    <>
            <AppHeader />
            <div className="app-main">
                <AppSidebar />
                <div className="app-main__outer">
                    <div className="app-main__inner">
                        <div className="parentGoal">
                            <div className="topSectionWrap">
                                <div className='googleAddWrap'>
                                    <Row>
                                        <Col lg="12" className="mx-auto">
                                            <Advert />
                                        </Col>
                                    </Row>
                                </div>
                                <div className='loginUser'>{t('hello')} <span className='logUserName'>{userData?.first_name + " " + userData?.last_name}</span></div>
                            </div>
                            {loading ?
              <div className="goalSummaryWrap">
                                    <Loading inline />
                                </div> :

              <>
                            <div className='goalSummaryWrap'>
                                <div className="mainTitle">{t('goalProgressSummary')}</div>
                                <div className='goalCardWrap'>
                                    <Row>
                                        <Col lg={3} xs={6}>
                                            <GoalNumberCard
                          cardColorClass='blue'
                          cardNumberData={goalData?.total}
                          cardName={t('allStudent')}
                          onClick={() => handleGoalCardClick('allStudent')}
                          isSelected={cardSelect?.allStudent} />

                                        </Col>
                                        <Col lg={3} xs={6}>
                                            <GoalNumberCard
                          cardColorClass='green'
                          cardNumberData={goalData?.green}
                          cardName={t('onTrack')}
                          onClick={() => handleGoalCardClick('onTrack')}
                          isSelected={cardSelect?.onTrack} />

                                        </Col>
                                        <Col lg={3} xs={6}>
                                            <GoalNumberCard
                          cardColorClass='yellow'
                          cardNumberData={goalData?.yellow}
                          cardName={t('atRisk')}
                          onClick={() => handleGoalCardClick('atRisk')}
                          isSelected={cardSelect?.atRisk} />

                                        </Col>
                                        <Col lg={3} xs={6}>
                                            <GoalNumberCard
                          cardColorClass='red'
                          cardNumberData={goalData?.red}
                          cardName={t('offTrack')}
                          onClick={() => handleGoalCardClick('offTrack')}
                          isSelected={cardSelect?.offTrack} />

                                        </Col>
                                        <Col lg={3} xs={6}>
                                            <GoalNumberCard
                          cardColorClass='brown'
                          cardNumberData={goalData?.brown}
                          cardName={t('transcriptMissing')}
                          onClick={() => handleGoalCardClick('atBrown')}
                          isSelected={cardSelect?.atBrown} />

                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className='studentProgressWrap'>
                                <div className="progressHeader">
                                    <div className="mainTitle">{t('allStudentsProgress')}</div>
                                    <div className="contactSearchWrap">
                                        <FontAwesomeIcon icon={faSearch} className="searchContactIcon" />
                                        <input
                                          type="text"
                                          className="form-control search-input contactSearch"
                                          placeholder={t('searchPlaceholder')}
                                          value={searchValue}
                                          autoComplete="off"
                                          onChange={handleStudentSearchChange}
                                        />
                                    </div>
                                </div>
                                <div className='progressWrap'>
                                    <Row>
                                        {filterStudentlist && filterStudentlist.length > 0 ?
                      filterStudentlist.map((item, index) => {
                        return (
                          <Col lg={6} key={index}>
                                                        <div className={`progressBlockWrp ${item?.status}`} onClick={() => handleStudentClick(item)}>
                                                            <div className='progressBlock'>
                                                                <div className='leftBlock'>
                                                                    <img src={item?.profile_image !== null ? `${item?.profile_image}` : IMG_URL + "placeholder.jpg"} alt='studentAvatarIcon' className='avatarIcon' />
                                                                    <div className='textBlock'>
                                                                        <div className='title'>{getStudentDisplayName(item)}</div>
                                                                        <div className='grade'>{t('gradeLabel')} {item?.current_grade}</div>
                                                                        <div className='status'><span className={`circleIcon ${item?.status}`}>&nbsp;</span>{getItemStatus(item?.status)}</div>
                                                                    </div>
                                                                </div>
                                                                <div className='rightBlock'>
                                                                    <img src={IMG_URL + "rightAngelIcon.png"} alt='rightAngelIcon' width={10} height={18} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>);

                      }) :
                      <Col lg={6}>
                                                <div>{getEmtptyArrMsg()}</div>
                                            </Col>}
                                    </Row>
                                </div>
                            </div>
                                </>}

                        </div>
                    </div>
                </div>
            </div>
        </>);

};

export default ParentGoal;